import React, { forwardRef, useRef } from 'react';
import { Input } from './Input.js';
import { classNames } from '@panwds/tailwindcss';
import { mergeRefs } from '../../utils/index.js';
import { CaretDownIcon, CaretUpIcon } from '@panwds/icons';
import { Button } from '../Button/Button.js';
const sizes = {
    sm: 'xs',
    md: 'xs',
    lg: 'sm'
};
const dimension = {
    sm: 'twds-h-[11px] twds-w-[22px]',
    md: 'twds-h-[15px] twds-w-[30px]',
    lg: 'twds-h-[19px] twds-w-[38px]'
};
const paddingX = {
    sm: 'twds-px-1',
    md: 'twds-px-2',
    lg: 'twds-px-3'
};
export const InputStepper = forwardRef(({ appearance, readOnly, disabled, size = 'md', className, dataTestId = 'input-stepper', dataMetrics, ...passThrough }, userRef) => {
    const internalRef = useRef(null);
    const ref = mergeRefs([userRef, internalRef]);
    return (React.createElement("div", { className: "twds-flex twds-w-fit" },
        React.createElement(Input, { ...passThrough, addClassName: className, type: "number", dataMetrics: dataMetrics, dataTestId: `${dataTestId}-input`, appearance: appearance, readOnly: readOnly, disabled: disabled, size: size, ref: ref, suffix: React.createElement("div", { className: classNames('twds-flex twds-flex-col twds-h-full twds-box-border twds-w-fit', 'twds-border-solid twds-border-t-0 twds-border-r-0 twds-border-b-0 twds-border-l-[1px]'), style: { borderColor: 'inherit' }, "data-metrics": dataMetrics, "data-testid": `${dataTestId}-button-container` },
                React.createElement(Button, { appearance: "tertiary-clear", "aria-label": "Increment", disabled: disabled, dataMetrics: dataMetrics, dataTestId: `${dataTestId}-up-button`, addClassName: classNames('twds-rounded-none twds-py-0 twds-rounded-tr focus:twds-outline-none  dark:focus:twds-outline-none', dimension[size], paddingX[size]), icon: React.createElement(CaretUpIcon, { size: sizes[size] }), onClick: readOnly || disabled
                        ? undefined
                        : () => {
                            if (!internalRef.current) {
                                return;
                            }
                            internalRef.current.stepUp();
                            const event = new Event('change', { bubbles: true });
                            internalRef.current?.dispatchEvent(event);
                        } }),
                React.createElement(Button, { appearance: "tertiary-clear", "aria-label": "Decrement", disabled: disabled, dataMetrics: dataMetrics, dataTestId: `${dataTestId}-down-button`, addClassName: classNames('twds-rounded-none twds-py-0 twds-rounded-br focus:twds-outline-none dark:focus:twds-outline-none', dimension[size], paddingX[size]), icon: React.createElement(CaretDownIcon, { size: sizes[size] }), onClick: readOnly || disabled
                        ? undefined
                        : () => {
                            if (!internalRef.current) {
                                return;
                            }
                            internalRef.current.stepDown();
                            const event = new Event('change', { bubbles: true });
                            internalRef.current?.dispatchEvent(event);
                        } })) })));
});
//# sourceMappingURL=input_stepper.js.map